export default __webpack_public_path__ + "static/media/dfl-3-rMIN.36b85f1c.avif";